module.exports = __webpack_public_path__ + "static/media/warning.cfc819aa.png";